export enum BetSlipType {
    simple = 1,
    system = 2,
}

export enum BetSlipErrorType {
    errorsInSelection = 'errorsInSelection',
    chooseTicketNegotiation = 'chooseTicketNegotiation',
    noSelectedSystemCombination = 'noSelectedSystemCombination',
    eventCantPlaceBets = 'eventCantPlaceBets',
    minimumStakeRaised = 'minimumStakeRaised',
    minSystemToPlay = 'minSystemToPlay',
    selectionIsUnavailable = 'selectionIsUnavailable',
    maxBetSlips = 'maxBetSlips',
    freeBetSystem = 'freeBetSystem',
    minEventsSystem = 'minEventsSystem',
    minSystemEventOdd = 'minSystemEventOdd',
    minSystemOdd = 'minSystemOdd',
    utilizationEvent = 'utilizationEvent',
    marketEvent = 'marketEvent',
    winLowerThanStake = 'winLowerThanStake',
    cantUseFreeBetBonus = 'cantUseFreeBetBonus',
    minEventOdd = 'minEventOdd',
}
